export default __webpack_public_path__ + "static/media/logo-icon.e638ae97.svg";